import { type Metric, onCLS, onINP, onLCP } from 'web-vitals';

declare global {
  interface Window {
    dataLayer?: object[];
  }
}

function pushMetric(metric: Metric): void {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'web_vitals',
    metricName: metric.name,
    metricValue: metric.value,
    metricId: metric.id,
    metricRating: metric.rating,
  });
}

export function initWebVitals(): void {
  onLCP(pushMetric);
  onCLS(pushMetric);
  onINP(pushMetric);
}
